/**
 * @author: subhasish.ghosh@zoom.us
 */

const TimeUnit = {
  MILLISECONDS: 1,
  SECONDS: 1000,
  MINUTES: 60000,
  HOURS: 3600000,
  DAYS: 86400000,

  /**
   * Convert a value from one time unit to another.
   * @param {number} value - The value to convert.
   * @param {number} fromUnit - The unit of the value.
   * @param {number} toUnit - The unit to convert to.
   * @returns {number} - The converted value.
   */
  convert(value, fromUnit, toUnit) {
    return (value * fromUnit) / toUnit;
  },
};

export const DATE_FORMAT = "YYYY-MM-DD";

export const DATE_FORMAT_EXPORT_FILE = "DDMMYYYY";

export default TimeUnit;
